<template>
  <div class="flex-mobile bg-white px-3">
    <component
      :is="mobileContent"
      :input-type="inputType"
      :is-registered-successfully="isRegisteredSuccessfully"
      :server-error-message="serverErrorMessage"
      @CheckPin="checkPin"
      @resendPin="resendPin"
    />
  </div>
</template>

<script>
import otpActivationForm from '@/components/OtpActivationForm.vue'
import vasSubscriptionForm from '@/components/VasSubscriptionForm.vue'

export default {
  name: 'FlexMobile',
  components: {
    otpActivationForm,
    vasSubscriptionForm
  },
  props: {
    mobileContent: Object,
    inputType: {},
    isRegisteredSuccessfully: Boolean,
    serverErrorMessage: String
  },
  methods: {
    checkPin (pin) {
      this.$emit('CheckPin', pin)
    },
    resendPin () {
      this.$emit('resendPin')
    }
  }
}
</script>
